import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Payment success is handled inline by CheckoutPage (Razorpay handler).
// This page is kept as a safe fallback redirect so any stale links don't 404.
export default function OrderSuccessPage() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/account", { replace: true });
  }, [navigate]);

  return null;
}
